module.exports = __webpack_public_path__ + "img/cover_photo.11971066.jpg";